var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlipIcon = function SvgFlipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.954 0a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1Zm0 5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1Zm-1 6a1 1 0 0 1 2 0v1a1 1 0 1 1-2 0v-1Zm1 4a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Zm-1 6a1 1 0 0 1 2 0v1a1 1 0 1 1-2 0v-1Zm-2-15.936V20a1 1 0 0 1-1 1H1.607a1 1 0 0 1-.886-1.464L9.068 4.6c.485-.926 1.886-.581 1.886.464Zm6 14.936V5.064c0-1.045 1.401-1.39 1.886-.464l8.348 14.936A1 1 0 0 1 26.302 21h-8.348a1 1 0 0 1-1-1Zm7.695-1-5.695-9.872V19h5.695Z",
    fill: "#455A64"
  })));
};
export default SvgFlipIcon;